/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PiclibFileUploadAllowedExtension } from './piclibFileUploadAllowedExtension';


export interface FormPagePropertyItemFileUploadInputFormatPiclibAllOf { 
    /**
     * ファイルカテゴリ(画像or文書)。 アップロード後、IMAGE の場合、サムネイルを表示する DOCUMENT の場合は、ファイルに応じたアイコンを表示する 
     */
    fileCategory: FormPagePropertyItemFileUploadInputFormatPiclibAllOf.FileCategoryEnum;
    /**
     * アップロード可能なファイルの拡張子を定義
     */
    allowedFileExtensions: Array<PiclibFileUploadAllowedExtension>;
    /**
     * アップロード可能なファイルの MimeType を定義
     */
    allowedFileMimeTypes: Array<string>;
    /**
     * ファイルを識別するID
     */
    subjectId: string;
    /**
     * ファイルサイズ上限値
     */
    fileSizeLimit: number;
}
export namespace FormPagePropertyItemFileUploadInputFormatPiclibAllOf {
    export type FileCategoryEnum = 'IMAGE' | 'DOCUMENT';
    export const FileCategoryEnum = {
        Image: 'IMAGE' as FileCategoryEnum,
        Document: 'DOCUMENT' as FileCategoryEnum
    };
}



